// extracted by mini-css-extract-plugin
export default {"main":"ListheadingWithSearch_main__K9Geo","heading":"ListheadingWithSearch_heading__5NF4P"};